module.exports = __webpack_public_path__ + "img/banner3.9fa8f3b9.jpg";